import type { DashboardConfig } from '../config';
import { clusterBase } from '../clusterBase';

export const ahConfig: DashboardConfig = {
  path: '/ah/campaign',
  reportId: 'ah-game-app-2026',
  label: 'AH Campagne',
  kind: 'ah',
  // AH campaign is over and its dedicated `ah` backend is being retired. The
  // (frozen) report is now served from the EU cluster, which holds the AH
  // catalog row + reporting payload. Repoint here, not on the `ah` cluster.
  apiBaseUrl: clusterBase('eu'),
  endsOn: '2026-07-05', // WC Albert Heijn, 8 Jun → 5 Jul — archived from the day after
  frozen: true, // pipeline retired — the frozen payload must never be regenerated
};
